







































import { defineComponent } from '@vue/composition-api';
import { capitalize } from '@getaccept/lib-shared/src/helpers';
import { DashboardWidgetHeaderColor } from '../../types/enums/dashboard-widget-header-color';
import DashboardWidgetList from '../DashboardWidgetList.vue';
import DashboardWidgetSkeleton from './DashboardWidgetSkeleton.vue';
import DashboardWidgetListSkeleton from './DashboardWidgetListSkeleton.vue';

export default defineComponent({
  name: 'DashboardBusinessSkeleton',
  components: {
    DashboardWidgetList,
    DashboardWidgetListSkeleton,
    DashboardWidgetSkeleton,
  },
  setup() {
    return {
      DashboardWidgetHeaderColor,
      capitalize,
    };
  },
});
